import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { ToastContainer } from 'react-toastify'

import { renderToastSuccessMsg, renderToastWarn } from 'utils/ToastUtils'

import ContentHeader from 'component/utils/ContentHeader'
import Breadcrumb from 'component/Breadcrumb'
import Grid from 'component/utils/Grid'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import Form from 'component/logoBrands/Form'
import Table from 'component/logoBrands/Table'
import LogoBrandsFilterForm from 'component/logoBrands/FilterForm'
import Notification from 'component/utils/Notification'
import Modal from 'component/logoBrands/Modal'

import * as logoBrandsActions from 'action/logoBrands'

class LogoBrandsContainer extends PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,

    deleteLogoBrands: PropTypes.func.isRequired,
    fetchLogoBrands: PropTypes.func.isRequired,
    saveLogoBrands: PropTypes.func.isRequired,
    getLogoBrands: PropTypes.func.isRequired,

    error: PropTypes.object,
    logoBrandsList: PropTypes.array.isRequired,
    success: PropTypes.string.isRequired,
    logoBrands: PropTypes.array,
    getUpdate: PropTypes.bool.isRequired,

    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,

    translate: PropTypes.func.isRequired,
  }

  constructor() {
    super()

    this.state = { modalType: '', currentItem: {}, filter: {}, page: 1 }
  }

  componentDidMount() {
    const {
      auth: {
        user: { dsToken },
      },
      fetchLogoBrands,
    } = this.props

    fetchLogoBrands(dsToken, this.state.filter, 1, 0)
  }

  componentDidUpdate(prevProps) {
    const { error, success, translate, logoBrands, getUpdate } = this.props
    const { currentItem, resetForm } = this.state

    if (success !== prevProps.success && success) {
      renderToastSuccessMsg(translate(success))
    } else if (error !== prevProps.error && error) {
      renderToastWarn(error)
    }

    if (getUpdate && !prevProps.getUpdate) {
      if (logoBrands.length > 0) {
      this.changeModal('UPDATE', currentItem)
      } else if (logoBrands.length === 0) {
        this.handleSave(currentItem, resetForm)
      }
    }
  }

  handleGetLogo = (values, onSuccessCallback) => {
    this.setState({ currentItem: values, resetForm: onSuccessCallback })

    const {
      auth: { user },
      getLogoBrands,
    } = this.props

    const filter = {
      nmBrand: values.nmBrand.value,
    }

    getLogoBrands(user.dsToken, filter)
  }

  handleSave = (values, onSuccessCallback) => {
    const {
      auth: {
        user: { dsToken },
      },
      saveLogoBrands,
      fetchLogoBrands,
    } = this.props

    const { filter, page } = this.state

    saveLogoBrands(dsToken, values, onSuccessCallback, filter, page).then(() =>
      fetchLogoBrands(dsToken, filter, page, 0)
    )
  }

  changeModal = (modalType, currentItem) => {
    this.setState({ modalType, currentItem })
  }

  getPage = (page) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchLogoBrands,
    } = this.props
    const { filter } = this.state

    this.setState({ page })
    fetchLogoBrands(dsToken, filter, page, 0)
  }

  handleChange = (filter, counter) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchLogoBrands,
    } = this.props

    this.setState({ filter })

    fetchLogoBrands(dsToken, filter, 1, counter)
  }

  renderNotification = () => {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('mobile-update.not-found')}
      />
    )
  }

  handleUpdate = () => {
    const { currentItem, resetForm } = this.state
    this.changeModal()
    this.handleSave(currentItem, resetForm)
  }

  renderModal = () => {
    const { translate, logoBrands } = this.props

    const { modalType, currentItem } = this.state

    if (!modalType) return

    return (
      <Modal
        changeModal={this.changeModal}
        currentItem={currentItem}
        handleDelete={this.handleDelete}
        handleSave={this.handleSave}
        modalType={modalType}
        translate={translate}
        oldImage={logoBrands[0]}
        handleUpdate={this.handleUpdate}
      />
    )
  }

  onSuccessCallback = () => {
    this.changeModal('')
     const {
      auth: {
        user: { dsToken },
      },
      fetchLogoBrands,
    } = this.props

    const { filter, page } = this.state
  fetchLogoBrands(dsToken, filter, page, 0)

  }

  handleDelete = () => {
    const {
      auth: {
        user: { dsToken },
      },
      deleteLogoBrands,
    } = this.props

    const { currentItem, filter, page } = this.state

    deleteLogoBrands(dsToken, currentItem, this.onSuccessCallback, filter, page)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('datasheetManagement') },
      { title: translate('datasheetManagement.logoBrands') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const {
      count,
      current,
      logoBrandsList,
      pages,
      translate,
      auth: { user },
    } = this.props

    return (
      <>
        <ContentHeader>{translate('datasheetManagement')}</ContentHeader>

        {this.renderBreadcrumb()}

        <Grid className='logo-brands-container'>
          <Col xs={12}>
            <LogoBrandsFilterForm
              handleChange={this.handleChange}
              translate={translate}
            />
          </Col>

          <Col xs={12} md={3}>
            <Form
              handleSubmit={this.handleGetLogo}
              translate={translate}
              user={user}
            />
          </Col>

          <Col xs={12} md={9}>
            {!logoBrandsList.length ? (
              this.renderNotification()
            ) : (
              <Table
                logoBrandsList={logoBrandsList}
                changeModal={this.changeModal}
                translate={translate}
              />
            )}

            {pages > 1 && (
              <Col xs={12} className='align-center'>
                <Pagination
                  count={count}
                  current={current}
                  getPage={this.getPage}
                  pages={pages}
                />
              </Col>
            )}
          </Col>

          {this.renderModal()}
        </Grid>

        <ToastContainer newestOnTop />
      </>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ logoBrandsReducer, paginateReducer }) => ({
  ...logoBrandsReducer,
  ...paginateReducer,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...logoBrandsActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    LogoBrandsContainer
  )
)

export { LogoBrandsContainer }
